import postHttp from './../../plugin/extendFn/postHttp'
import loginService from './../../plugin/extendFn/loginService'
import main from '../../main'

function autoLogin(shareKey) {
    return new Promise((resolve, reject) => {
        /**
         * ?shareKey=790aa76a858e4984a42e2c444f07bf6c
         * 1.存在 shareKey ,就实现自动登录
         */
        // 系统自动登录
        postHttp(`/ra-app/api/share-qrcode/autoLogin/${shareKey}`).then(async (res) => {
            console.log("autoLogin >>> res=", res)
            var code = res.data.code;
            var userEntity = res.data.data;
            // 重新加载页面。
            if (code == 0 && userEntity) {
                // 存储上登录数据
                await loginService.setLoginUser(userEntity)
                main.vue.$message.success("登录成功!")
            }
            else {
                this.topTips("此链接已失效!")
                // 需要退出登录状态
                loginService.logout();
            }
        })
        .catch(() => {
            main.vue.$message.error("此链接已失效!")
             // 需要退出登录状态
             loginService.logout();
        })
        .finally(()=>{
            resolve();
        })
    })
}

function ShareKeyGard(to, from, next) {
    console.log("gard >>> ShareKeyGard ----------------------------------------");
    var shareKey = to.query.shareKey;
    if (!shareKey) {
        next();
    }
    else  // 分享自动登录
    {
        console.log("自动登录！")
        autoLogin(shareKey).finally(()=>{
            next({
                path: to.path  // 去除参数。 
            });
        })
    }
}


export default ShareKeyGard;



// WEBPACK FOOTER //
// ./src/router/gard/ShareKeyGard.js